function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Icon/Big/LowSun"
}, React.createElement("g", {
  id: "Group 12"
}, React.createElement("path", {
  id: "Combined Shape",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.6519 17.538H35.3481V1H33.6519V17.538ZM34.5 22.6266C28.4208 22.6266 23.4747 27.5727 23.4747 33.6519C23.4747 39.7311 28.4208 44.6772 34.5 44.6772C40.5792 44.6772 45.5253 39.7311 45.5253 33.6519C45.5253 27.5727 40.5792 22.6266 34.5 22.6266ZM34.5 46.3734C27.4854 46.3734 21.7785 40.6665 21.7785 33.6519C21.7785 26.6373 27.4854 20.9304 34.5 20.9304C41.5146 20.9304 47.2215 26.6373 47.2215 33.6519C47.2215 40.6665 41.5146 46.3734 34.5 46.3734ZM35.3481 49.7658V68H33.6519V49.7658H35.3481ZM1 35.3481H17.538V33.6519H1V35.3481ZM68 35.3481H50.6139V33.6519H68V35.3481ZM22.451 21.954L11.0602 10.5632L12.2594 9.36397L23.6502 20.7548L22.451 21.954ZM46.6216 46.1247L58.4365 57.9396L59.6357 56.7404L47.8208 44.9255L46.6216 46.1247ZM11.4116 57.9396L10.2124 56.7404L21.1792 45.7736L22.3784 46.9728L11.4116 57.9396ZM45.7738 21.1789L46.973 22.3781L58.7879 10.5632L57.5887 9.36397L45.7738 21.1789Z",
  fill: "#6E6E6E"
})));

var SvgLowSun = function SvgLowSun(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLowSun, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/low-sun.9bfac918.svg";
export { ForwardRef as ReactComponent };